export default "__VITE_ASSET__C0tn_j_g__"